module.exports = __webpack_public_path__ + "img/biggestVolume.37e9f68b.svg";